import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getByQuery } from "../../api/API";

const VerifyEmail = () => {
  const [loading, setLoading] = useState(true);
  const [paymentToken, setPaymentToken] = useState(null);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const emailToken = searchParams.get("token");

    if (!emailToken) {
      toast.error("Invalid verification link.");
      navigate("/login");
      return;
    }

    const verifyEmail = async () => {
      try {
        const res = await getByQuery("/verify-email", `token=${emailToken}`);

        if (!res?.success) {
          throw new Error("Verification failed");
        }

        // FREE COHORT redirect immediately
        if (res.free === true || Number(res.amount) === 0) {
          toast.success("Email verified. Registration completed!");
          navigate("/login", { replace: true });
          return;
        }

        // PAID COHORT
        if (typeof res.paymentToken === "string") {
          setPaymentToken(res.paymentToken);
          toast.success("Email verified successfully!");
        } else {
          throw new Error("Payment token missing");
        }
      } catch (err) {
        console.error("Verification error:", err);
        toast.error("Invalid or expired verification link.");
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  const handleProceedToPayment = () => {
    if (!paymentToken) {
      toast.error("Payment session expired. Please login again.");
      navigate("/login");
      return;
    }

    navigate(`/payment-member-info?token=${paymentToken}`);
  };

  return (
    <div
      className="auth-page"
      // style={{
      //   backgroundImage: `url("/assets/images/loginsignbg.png")`,
      //   backgroundSize: "cover",
      //   backgroundPosition: "center",
      //   minHeight: "100vh",
      //   display: "flex",
      //   justifyContent: "center",
      //   alignItems: "center",
      //   padding: "20px",
      // }}
    >
      <div
        className="auth-box bg-white p-5 rounded shadow text-center"
        style={{
          maxWidth: "420px",
          width: "100%",
          background: "rgba(255,255,255,0.95)",
        }}
      >
        {loading && <p className="text-muted">Verifying your email…</p>}

        {!loading && paymentToken && (
          <>
            <h2 className="fw-bold mb-3">Email Verified</h2>
            <p className="mb-4">
              Complete your payment to activate your account.
            </p>

            <button
              className="auth-btn bg-primary text-white w-100"
              onClick={handleProceedToPayment}
            >
              Proceed to Payment
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
